export function getDomainSlug(): string | null {
    const { hostname, port } = window.location;
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
    const isApp = hostname === "peaceandwork.trigger-flow.com";

    if ((isLocalhost && (port === "3005" || port === "5173" || port === "")) || isApp) return null;

    return hostname;
}

